import * as poseDetection from '@tensorflow-models/pose-detection';
import '@tensorflow/tfjs-core';
import '@tensorflow/tfjs-backend-webgl';
import '@mediapipe/pose';

export function findLastExtremes(data) {
	if (data.length < 3) {
		console.log("Data length is too short to find extremes.");
		return {
			maxima: [],
			minima: []
		}; // 返回空的极值列表
	}

	let maxima = [];
	let minima = [];
	let lastExtreme = null; // 存储上一个极值点

	// 从第二个数据点开始遍历到倒数第二个数据点
	for (let i = 1; i < data.length - 1; i++) {
		const prev = data[i - 1];
		const current = data[i];
		const next = data[i + 1];

		// 检查极大值
		if (current.angle > prev.angle && current.angle > next.angle) {
			if (!lastExtreme || Math.abs(current.angle - lastExtreme.angle) >= 50) {
				maxima.push({
					angle: current.angle,
					timestamp: current.timestamp
				});
				lastExtreme = current; // 更新上一个极值点
			}
		}

		// 检查极小值
		if (current.angle < prev.angle && current.angle < next.angle) {
			if (!lastExtreme || Math.abs(current.angle - lastExtreme.angle) >= 50) {
				minima.push({
					angle: current.angle,
					timestamp: current.timestamp
				});
				lastExtreme = current; // 更新上一个极值点
			}
		}
	}

	// 去除最后一个未完成的极值点
	if (maxima.length && minima.length) {
		if (maxima[maxima.length - 1].timestamp > minima[minima.length - 1].timestamp) {
			maxima.pop(); // 去除最后一个波峰
		}
	}

	// 直接返回包含波峰和波谷数组的对象
	return {
		maxima,
		minima
	};
}
export function calculateTimeDifferences(data) {

	const extremes = this.findLastExtremes(data);

	if (extremes.maxima.length < 3 || extremes.minima.length < 3) {
		console.log("Not enough data points to calculate speeds.");
		return; // 确保有足够的数据点来进行计算
	}



	// 获取倒数第二和第三的波峰时间
	const maxTimeDiff = extremes.maxima[extremes.maxima.length - 1].timestamp - extremes.minima[extremes.minima.length - 2].timestamp;
	const minTimeDiff = extremes.minima[extremes.minima.length - 1].timestamp - extremes.maxima[extremes.maxima.length - 1].timestamp;

	// 计算出浆速度和收浆速度
	var outputSpeed = maxTimeDiff / 1000; // 转换为秒
	var recoverySpeed = minTimeDiff / 1000; // 转换为秒

	// 计算浆频（次数/分钟）
	const totalCycleTime = outputSpeed + recoverySpeed; // 总浆行周期时间（秒）
	const strokesPerMinute = 60 / totalCycleTime; // 一分钟内的浆次数
	outputSpeed = outputSpeed.toFixed(2)
	recoverySpeed = recoverySpeed.toFixed(2)
	var that = this


	that.crc_count = parseInt(strokesPerMinute)


	console.log(strokesPerMinute);
	return {
		outputSpeed,
		recoverySpeed,
		strokesPerMinute
	};
}
export function u_avg(name, avg) {
	var that = this
	avg = parseFloat(avg);

	// 获取当前关节的推荐范围
	const range = that.$data.dat_line[name];

	if (!range) return; // 如果没有找到对应关节的范围，则直接返回

	let color = "red"; // 默认设置为红色
	// 检查第一组范围
	if (avg >= range.u_min && avg <= range.u_max) {
		color = "green"; // 在推荐范围内
	} else if ((avg >= range.u_min - 3 && avg < range.u_min) || (avg <= range.u_max + 3 && avg > range.u_max)) {
		color = "yellow"; // 在推荐范围的±3度内
	}

	// 如果存在第二组范围，也进行检查
	if (range.d_min !== undefined && range.d_max !== undefined) {
		if (avg >= range.d_min && avg <= range.d_max) {
			color = "green"; // 在第二组推荐范围内
		} else if ((avg >= range.d_min - 3 && avg < range.d_min) || (avg <= range.d_max + 3 && avg > range.d_max)) {
			color = color === "green" ? "green" : "yellow"; // 如果已经是绿色，则保持不变，否则设为黄色
		}
	}

	// 更新颜色和角度值
	that.$data.dat[name].color = color;
	that.$data.dat[name].val = avg.toFixed(1);

	// 更新角度数据数组
	if (that.$data.dats[name].length == 0 || that.$data.dats[name][that.$data.dats[name].length - 1] != avg) {
		that.$data.dats[name].push(avg);
	}

	that.$data.dat[name].val = parseFloat(avg).toFixed(1);
	if (that.$data.dat[name + "_min"].val > avg || that.$data.dat[name + "_min"].val == "0") {
		that.$data.dat[name + "_min"].val = parseFloat(avg).toFixed(1);
		that.$data.dat[name + "_min"].color = that.updateColor(parseFloat(avg).toFixed(1), range)
		if (that.$data.jt) {
			that.$data.dat[name + "_min"].img = that.canvas5.toDataURL("image/png");
		}
	}
	if (that.$data.dat[name + "_max"].val < avg || that.$data.dat[name + "_max"].val == "0") {
		that.$data.dat[name + "_max"].val = parseFloat(avg).toFixed(1);
		that.$data.dat[name + "_max"].color = that.updateColor(parseFloat(avg).toFixed(1), range)
		if (that.$data.jt) {
			that.$data.dat[name + "_max"].img = that.canvas5.toDataURL("image/png");
		}
	}
	if (name == "knee") {
		if (that.shoulderData[that.shoulderData.length - 1].angle != parseFloat(avg)) {
			that.shoulderData.push({
				angle: parseFloat(avg),
				timestamp: Date.now()
			})
			if (that.shoulderData.length > 1000) {
				that.shoulderData.shift(); // 移除数组最前面的元素
			}
			if (that.shoulderData.length % 20 == 0) {
				var str = "";
				for (var i in that.shoulderData) {
					str += that.shoulderData[i].angle + ","

				}


			}
			if (that.shoulderData.length > 10) {
				that.calculateTimeDifferences(that.shoulderData);
			}
		}


	}
	// var sum=0;
	// for(var i in that.$data.dats[name]){
	// 	sum+=parseFloat(that.$data.dats[name][i])
	// }				
	// that.$data.dat[name+"_avg"].val=(sum/that.$data.dats[name].length).toFixed(1);

}

export function updateGauge() {


	// {{fs[map_name]}}参考范围
	// <span>最大伸展：{{dat_line[map_name].u_max}}-{{dat_line[map_name].u_min}}°</span>


	var that = this
	const kneeRange = {
		maxExtension: {
			min: that.dat_line[that.map_name].u_min,
			max: that.dat_line[that.map_name].u_max
		}, // 最大伸展范围
		minFlexion: {
			min: that.dat_line[that.map_name].d_min,
			max: that.dat_line[that.map_name].d_max
		}, // 最小收缩范围
	};
	// 将参考范围转换为仪表图上的比例
	const scale = (value, total) => value / total;
	var min = kneeRange.maxExtension.min - 10 // 最小值
	var max = kneeRange.maxExtension.max + 10 // 最大值
	var length = max - min;
	// 设置仪表图的颜色区间
	var colorRanges = [
		[0, '#fd666d'],
		[((kneeRange.maxExtension.min - min - 3) / length), '#fd666d'], // 最大伸展-5度为红色终点

		[((kneeRange.maxExtension.min - min) / length), '#ece864'], // 最大伸展范围为绿色起点

		[((kneeRange.maxExtension.max - min) / length), '#00B83F'], // 最大伸展范围为绿色终点
		[((kneeRange.maxExtension.max - min + 3) / length), '#ece864'], // 最大伸展范围为绿色终点					

		[1, '#fd666d'], // 到180度都为红色
	];


	var option_ybt = {
		series: [{
			animation: true,
			type: 'gauge',
			type: 'gauge',
			min: min, // 最小值
			max: max, // 最大值
			axisLine: {
				lineStyle: {
					width: 4,
					color: colorRanges,
				}
			},
			pointer: {
				itemStyle: {
					color: 'auto'
				}
			},
			axisTick: {
				distance: -30,
				length: 8,
				lineStyle: {
					color: '#fff',
					width: 2
				}
			},
			splitLine: {
				distance: -30,
				length: 30,
				lineStyle: {
					color: '#fff',
					width: 4
				}
			},
			axisLabel: {
				show: false,
				color: 'inherit',
				interval: 1,
				distance: 40,
				fontSize: 12,
				formatter: function(value) {
					// 只显示最小值和最大值的标签

					return value;

				},
			},
			detail: {
				valueAnimation: true,
				formatter: '{value}°',
				color: 'inherit'
			},
			data: [{
				value: that.avg_max
			}]
		}]
	};

	option_ybt && that.ybt.setOption(option_ybt);


	// 将参考范围转换为仪表图上的比例

	var min = kneeRange.minFlexion.min - 10 // 最小值
	var max = kneeRange.minFlexion.max + 10 // 最大值
	var length = max - min;
	// 设置仪表图的颜色区间
	var colorRanges = [
		[0, '#fd666d'],
		[((kneeRange.minFlexion.min - min - 3) / length), '#fd666d'], // 最大伸展-5度为红色终点

		[((kneeRange.minFlexion.min - min) / length), '#ece864'], // 最大伸展范围为绿色起点

		[((kneeRange.minFlexion.max - min) / length), '#00B83F'], // 最大伸展范围为绿色终点
		[((kneeRange.minFlexion.max - min + 3) / length), '#ece864'], // 最大伸展范围为绿色终点					

		[1, '#fd666d'], // 到180度都为红色
	];


	var option_ybt2 = {
		series: [{
			animation: true,
			type: 'gauge',
			type: 'gauge',
			min: min, // 最小值
			max: max, // 最大值
			axisLine: {
				lineStyle: {
					width: 4,
					color: colorRanges,
				}
			},
			pointer: {
				itemStyle: {
					color: 'auto'
				}
			},
			axisTick: {
				distance: -30,
				length: 8,
				lineStyle: {
					color: '#fff',
					width: 2
				}
			},
			splitLine: {
				distance: -30,
				length: 30,
				lineStyle: {
					color: '#fff',
					width: 4
				}
			},
			axisLabel: {
				show: false,
				color: 'inherit',
				interval: 1,
				distance: 40,
				fontSize: 12,
				formatter: function(value) {
					// 只显示最小值和最大值的标签

					return value;

				},
			},
			detail: {
				valueAnimation: true,
				formatter: '{value}°',
				color: 'inherit'
			},
			data: [{
				value: that.avg_min
			}]
		}]
	};

	option_ybt2 && that.ybt2.setOption(option_ybt2);
}
export function save_af() {
	var that = this
	if (confirm("确认结束动态评估？")) {
		if (that.crc_count < 60) {
			alert("请保持踏频大于60再点击保存");
			return 0;
		}
		that.is_cut = true;
		$.ajax({
			url: that.URL,
			method: "POST",
			data: {
				t: "save_af",
				token: localStorage.getItem('token'),
				id: that.$data.id,
				bf_dat: JSON.stringify(that.$data.dat),
				fx: that.$data.dat.see_fx.val,
				bf_img: that.canvas4.toDataURL(),
				wd1: that.canvas2.toDataURL(),
				wd2: that.canvas3.toDataURL(),
				wd3: that.canvas6.toDataURL(),

			},
			dataType: "json",
			success(e) {
				that.is_cut = false;
				// that.jref_r('/finish?id=' + that.$data.id);
				location.href = "https://bike.typhcl.cn/dev/step6.php?id=" + that.$data.id + "&token=" + localStorage.getItem('token')
			}
		})
	}

}
export function save_fq() {
	var that = this

	if (that.crc_count < 60) {
		alert("请保持踏频大于60再点击保存");
		return 0;
	}
	that.is_cut = true;
	$.ajax({
		url: that.URL,
		method: "POST",
		data: {
			t: "save_fq",
			token: localStorage.getItem('token'),
			id: that.$data.id,
			bf_dat: JSON.stringify(that.$data.dat),
			fx: that.$data.dat.see_fx.val,
			bf_img: that.canvas4.toDataURL(),
			wd1: that.canvas2.toDataURL(),
			wd2: that.canvas3.toDataURL(),
			wd3: that.canvas6.toDataURL(),

		},
		dataType: "json",
		success(e) {
			that.is_cut = false;
			that.$data.sta = 1;
			that.clear();
		}
	})
}
export function init_dat() {
	var that = this
	$.ajax({
		url: that.URL,
		data: {
			t: "fitting_init",
			token: localStorage.getItem('token'),
			id: that.$data.id,
		},
		dataType: "json",
		success(e) {
			if (e.pid == 0) {
				that.$router.replace('/login');
			}
			if (e.free) {
				that.$router.replace('/free');
			}
			that.$data.ck_list = e.list;
		}
	});
}

export function wd_clean() {
	var that = this;
	that.ctx2.clearRect(0, 0, that.canvas4.width, that.canvas4.height);
	that.ctx3.clearRect(0, 0, that.canvas3.width, that.canvas3.height);
	that.ctx6.clearRect(0, 0, that.canvas6.width, that.canvas6.height);
}

export function set_map_name(name) {
	this.$data.map_name = name;
}

export function calculatePeakValleyAverages(data, threshold) {
	let peaks = [];
	let valleys = [];
	let previous = data[0];

	var smoothed = data;
	for (let i = 1; i < smoothed.length - 1; i++) {
		if (smoothed[i] > smoothed[i - 1] && smoothed[i] > smoothed[i + 1] && smoothed[i] - previous > threshold) {
			peaks.push({
				value: smoothed[i],
				index: i
			});
			previous = smoothed[i];
		} else if (smoothed[i] < smoothed[i - 1] && smoothed[i] < smoothed[i + 1] && previous - smoothed[i] > threshold) {
			valleys.push({
				value: smoothed[i],
				index: i
			});
			previous = smoothed[i];
		}
	}

	if (peaks.length > 2 && valleys.length > 2) {
		peaks = peaks.slice(1, -1);
		valleys = valleys.slice(1, -1);
	}

	peaks = peaks.map(p => p.value).sort((a, b) => a - b);
	valleys = valleys.map(v => v.value).sort((a, b) => a - b);

	if (peaks.length > 4) {
		peaks = peaks.slice(2, -2);
	}
	if (valleys.length > 4) {
		valleys = valleys.slice(2, -2);
	}

	var actual_max = Math.max(...data);
	var actual_min = Math.min(...data);

	var avg_max = peaks.length ? peaks.reduce((a, b) => a + b, 0) / peaks.length : 0;
	var avg_min = valleys.length ? valleys.reduce((a, b) => a + b, 0) / valleys.length : 0;

	return {
		avg_max,
		avg_min,
		actual_max,
		actual_min
	};
}
export function ref_fps() {
	var that = this;
	//刷新fps
	that.fps = that.fps_count;
	that.fps_count = 0;

}
export function ai_fix() {
	//AI分析调车
	//判断曲柄，判断坐垫高度，判断前伸量，优化踩踏姿势
	var that = this
	if (!that.zt) {
		return 0;
	}
	for (var i in that.avgs) {
		var data = that.$data.dats[i];
		var dat_count = 100 + that.fps * 5;
		if (data.length > dat_count) {
			data = data.slice(-dat_count);
		}

		var threshold = (that.$data.dat[i + '_max'].val - that.$data.dat[i + '_min'].val) / 8;
		var recall = that.calculatePeakValleyAverages(data, threshold);

		that.avgs[i].max = recall.avg_max;
		that.avgs[i].min = recall.avg_min;
	}

	that.dsc = "";
	var dsc = "";
	if (that.crc_count < 75) {
		that.dsc = "请保持踏频75以上。"
		return 0;
	}
	if (that.avgs.knee.max > 153 && that.avgs.knee.min < 62) {
		dsc += "曲柄过长，建议更换短曲柄后尝试。\n"

	} else {
		if (that.avgs.knee.max < 133 && that.avgs.knee.min > 78) {
			dsc += "曲柄过短，建议更换长曲柄后尝试。\n"

		} else {
			if (that.avgs.knee.max > 153 && that.avgs.knee.min > 67) {
				dsc += "坐垫过高，建议降低坐垫高度。\n"

			} else {
				if (that.avgs.knee.max < 145 && that.avgs.knee.min < 63) {
					dsc += "坐垫过低，建议增加坐垫高度。\n"

				}
			}
		}
	}
	if (that.dat.fknee_min.val < -20) {
		dsc += "膝前量不足，请将坐垫调整靠后，并清空数据复测。\n"

	}
	if (that.avgs.hip.max > 108) {
		dsc += "请将坐垫靠后或增加把立长度，以增加前伸量。\n"

	} else {
		if (that.avgs.hip.min < 52) {
			dsc += "请将坐垫靠前或减小把立长度，以减小前伸量。\n"
		}
	}
	if (dsc == "") {
		dsc = "姿态良好。";
	}
	if (dsc == that.show_ai_tmp) {
		that.show_ai++;
		if (that.show_ai > 8) {
			that.dsc = that.show_ai_tmp;
		} else {
			that.dsc = "Ai分析中...";
		}
	} else {
		that.show_ai = 1;
		that.show_ai_tmp = dsc;
		that.dsc = "Ai分析中...";

	}
	console.log(that.show_ai_tmp);





}
export function ref_map() {
	var that = this;
	that.ai_fix();
	//刷新fps	
	var data = that.$data.dats[that.$data.map_name];
	var dat_count = 100 + that.fps * 5;
	if (data.length > dat_count) {
		data = data.slice(-dat_count);
	}

	var threshold = (that.$data.dat[that.$data.map_name + '_max'].val - that.$data.dat[that.$data.map_name + '_min'].val) / 8;
	var recall = that.calculatePeakValleyAverages(data, threshold);

	var avg_max = recall.avg_max;
	var avg_min = recall.avg_min;
	var show_max = recall.actual_max;
	var show_min = recall.actual_min;
	that.show_max = show_max.toFixed(2);
	that.show_min = show_min.toFixed(2);
	that.show_max_c = that.updateColor(that.show_max, that.dat_line[that.map_name]);
	that.show_min_c = that.updateColor(that.show_min, that.dat_line[that.map_name]);

	that.avg_max = avg_max.toFixed(2);
	that.avg_min = avg_min.toFixed(2);
	const range = that.$data.dat_line[that.$data.map_name];
	let statusNormal = true;
	let statusMessage = "状态正常";
	let isHigh = false;
	const countInNormalRange = data.filter(point => (point >= range.u_min && point <= range.u_max) || (point >= range.d_min && point <= range.d_max)).length;
	const percentageInNormalRange = countInNormalRange / data.length;

	if (percentageInNormalRange < 0.8) {
		for (let i = 0; i < data.length; i++) {
			if (data[i] > range.u_max) {
				statusNormal = false;
				statusMessage = range.u_min_title;
				isHigh = true;
				break;
			} else if (data[i] < range.u_min) {
				statusNormal = false;
				statusMessage = range.u_max_title;
			}
		}

		if (!isHigh && typeof(range.d_max_title) != 'undefined') {
			for (let i = 0; i < data.length; i++) {
				if (data[i] < range.d_min) {
					statusNormal = false;
					statusMessage = range.d_max_title;
					break;
				} else if (data[i] > range.d_max) {
					statusNormal = false;
					statusMessage = range.d_min_title;
					break;
				}
			}
		}
	}

	// if (statusMessage == "") {
	// 	statusMessage = "状态正常";
	// }
	// that.$data.dsc = statusMessage;

	var dataLength = data.length;
	var requiredLength = 100;
	if (dataLength < requiredLength) {
		var padding = new Array(requiredLength - dataLength).fill(90);
		data = padding.concat(data);
	}

	const dataMax = Math.max(...data);
	const dataMin = Math.min(...data);

	const referenceLines = [range.u_min, range.u_max, range.d_min, range.d_max];
	const adjustedMax = Math.max(dataMax, ...referenceLines);
	const adjustedMin = Math.min(dataMin, ...referenceLines);
	var yAxisMax = adjustedMax + 10;
	var yAxisMin = adjustedMin - 10 < 0 ? 0 : adjustedMin - 10;

	var option = {
		animation: false,
		grid: {
			left: 0,
			right: 0,
			top: 0,
			bottom: 0,
			containLabel: false
		},
		xAxis: {
			type: 'category',
			data: [],
			show: false,
		},
		yAxis: {
			type: 'value',
			show: false,
			min: yAxisMin,
			max: yAxisMax
		},
		series: [{
			data: data,
			type: 'line',
			smooth: true,
			itemStyle: {
				color: 'green'
			},
			showSymbol: false,
			lineStyle: {
				width: 2
			},
			markLine: {
				silent: true,
				symbol: ['none', 'none'],
				data: [{
						yAxis: range.u_min,
						lineStyle: {
							color: '#fff',
							type: 'dashed'
						}
					},
					{
						yAxis: range.u_max,
						lineStyle: {
							color: '#fff',
							type: 'dashed'
						}
					},
				]
			}
		}],
		splitLine: {
			show: true,
			lineStyle: {
				color: '#fff',
				type: 'solid'
			}
		}
	};

	if (range.d_min !== undefined && range.d_max !== undefined) {
		option.series[0].markLine.data.push({
			yAxis: range.d_min,
			lineStyle: {
				color: '#fff',
				type: 'dashed'
			}
		}, {
			yAxis: range.d_max,
			lineStyle: {
				color: '#fff',
				type: 'dashed'
			}
		});
	}

	option && that.myChart.setOption(option);
	that.updateGauge();
}

export function pause() {
	var that = this;
	if (!that.$data.zt) {
		setTimeout(function() {
			that.can_fknee = true;
		}, 1000);
		that.video.play();
	} else {
		that.video.pause();
	}
	that.$data.zt = !that.$data.zt;
}

export function go_init() {
	var that = this;
	if (that.ready) {
		setTimeout(function() {
			that.set_cam_v();
			that.startPoseDetection();
		}, 3000);
	} else {
		setTimeout(function() {
			that.go_init();
		}, 2000);
	}
}
export async function next_cam() {
	var that = this;
	if (that.$data.cam_index == (that.$data.allVideoDevices.length) - 1) {
		that.$data.cam_index = 0;
	} else {
		that.$data.cam_index++;
	}
	try {
		const stream = await navigator.mediaDevices.getUserMedia({
			video: {
				deviceId: {
					exact: that.$data.allVideoDevices[that.$data.cam_index].deviceId
				}
			}
		});

		const videoTrack = stream.getVideoTracks()[0];
		const settings = videoTrack.getSettings();
		that.set_cam_v(settings.width, settings.height);

		var video = document.getElementsByTagName("video")[0];
		that.video.srcObject = stream;
		that.video.play();
	} catch (error) {
		console.error('Error switching cameras:', error);
		this.call = error;
	}
}

export function clear() {
	var that = this;
	that.foot_index_max = 0;
	that.can_fknee = false;
	if (!that.$data.zt) {

	} else {
		setTimeout(function() {
			that.can_fknee = true;
		}, 1000);
	}
	that.$data.dat = JSON.parse(JSON.stringify(that.$data.def_dat));
	that.$data.dats = {
		"knee": [],
		"hip": [],
		"shoulder": [],
		"elbow": [],
		"ankle": [],
		"wrist": []
	};
}

export function set_cam_v() {
	var that = this;

	var vh = that.video.videoHeight;
	var vw = that.video.videoWidth;
	that.canvas5.width = that.video.offsetWidth;
	that.canvas5.height = that.video.offsetHeight;
	that.canvas4.width = that.video.offsetWidth;
	that.canvas4.height = that.video.offsetHeight;
	that.canvas1.width = that.video.offsetWidth / 3;
	that.canvas1.height = that.video.offsetHeight / 3;
	that.canvas6.width = that.video.offsetWidth / 3;
	that.canvas6.height = that.video.offsetHeight / 3;
	that.canvas2.width = that.video.offsetWidth / 3;
	that.canvas2.height = that.video.offsetHeight / 3;
	that.canvas3.width = that.video.offsetWidth / 3;
	that.canvas3.height = that.video.offsetHeight / 3;
}

export async function initCamera() {
	var that = this;
	try {
		that.video.addEventListener('loadedmetadata', function() {});
		const stream = await navigator.mediaDevices.getUserMedia({
			video: true
		});
		const videoTrack = stream.getVideoTracks()[0];
		const settings = videoTrack.getSettings();
		that.video.srcObject = stream;
		that.$data.call = "";
		that.video.play();

		try {
			const devices = await navigator.mediaDevices.enumerateDevices();
			that.$data.allVideoDevices = devices.filter(device => device.kind === 'videoinput');
		} catch (error) {
			console.error('Error listing cameras:', error);
			that.$data.call = "未发现可用摄像头，进入演示模式，尝试刷新";
		}
		that.stas = 1;
	} catch (error) {
		that.$data.call = "未发现可用摄像头，进入演示模式，尝试刷新";
	}
}

export function captureCurrentFrame() {
	var canvas1 = document.getElementsByTagName('canvas')[0];
	var canvas2 = document.getElementsByTagName('canvas')[1];

	var mergedCanvas = document.createElement('canvas');
	var ctx = mergedCanvas.getContext('2d');

	var vl = 1 / uni.getSystemInfoSync().pixelRatio;

	mergedCanvas.width = Math.max(canvas1.width, that.canvas2.width) * vl;
	mergedCanvas.height = Math.max(canvas1.height, that.canvas2.height) * vl;

	that.ctx.scale(vl, vl);
	that.ctx.drawImage(canvas2, 0, 0);
	that.ctx.drawImage(canvas1, 0, 0);

	return mergedCanvas.toDataURL('image/png');
}

export function updateAngleAndCaptureImage(jointName, newAngle) {
	var that = this;
	if (typeof(that.img_list[jointName]) == 'undefined') {
		that.img_list[jointName] = {
			maxAngle: 0,
			minAngle: 360,
			maxImage: '',
			minImage: ''
		};
	}
	var newAngle = parseFloat(newAngle);

	if (newAngle > that.img_list[jointName].maxAngle) {
		that.img_list[jointName].maxAngle = newAngle;
		that.img_list[jointName].maxImage = that.captureCurrentFrame();
	}

	if (newAngle < that.img_list[jointName].minAngle) {
		that.img_list[jointName].minAngle = newAngle;
		that.img_list[jointName].minImage = that.captureCurrentFrame();
	}
}

export async function init_mode() {
	var that = this
	const model = poseDetection.SupportedModels.BlazePose;
	const detectorConfig = {
		runtime: 'mediapipe',
		solutionPath: 'https://bike-1251293106.cos.ap-chengdu.myqcloud.com/mode/',
		modelType: 'heavy'
	};
	that.detector = await poseDetection.createDetector(model, detectorConfig);
	this.sta = "";
	this.$data.ready = true;
	this.initCamera();
}

export function updateColor(value, range) {
	if (value >= range.u_min && value <= range.u_max || (range.d_min !== undefined && value >= range.d_min && value <= range.d_max)) {
		return "green";
	} else if ((value >= range.u_min - 3 && value < range.u_min) || (value <= range.u_max + 3 && value > range.u_max) || (range.d_min !== undefined && ((value >= range.d_min - 3 && value < range.d_min) || (value <= range.d_max + 3 && value > range.d_max)))) {
		return "yellow";
	} else {
		return "red";
	}
}

export function updateknee_x(newAngles, showLeftSide) {
	var that = this;
	if (!that.can_fknee) {
		console.log("拦截更新");
		return 0;
	}
	if (newAngles[0][0] == 0 || newAngles[0][0] == 0) {
		return 0;
	}

	if (showLeftSide) {
		var val = parseFloat(newAngles[1][0] - newAngles[0][0]).toFixed(1);
		if ((that.dat.fknee_min.val > val) || parseInt(that.dat.fknee_min.val) == 0) {
			that.dat.fknee_min.val = val;

			if (that.dat.fknee_min.val < -30) {
				that.dat.fknee_min.color = "red";
			} else {
				if (that.dat.fknee_min.val < 0) {
					that.dat.fknee_min.color = "yellow";
				} else {
					that.dat.fknee_min.color = "green";
				}
			}
		}
	} else {
		var val = (newAngles[0][0] - newAngles[1][0]).toFixed(1);
		if ((that.dat.fknee_min.val > val) || parseInt(that.dat.fknee_min.val) == 0) {
			that.dat.fknee_min.val = val;

			if (that.dat.fknee_min.val < -30) {
				that.dat.fknee_min.color = "red";
			} else {
				if (that.dat.fknee_min.val < 0) {
					that.dat.fknee_min.color = "yellow";
				} else {
					that.dat.fknee_min.color = "green";
				}
			}
		}
	}
}
export function calculateAngle(A, B, C) {
	const BA = [A.x - B.x, A.y - B.y, A.z - B.z];
	const BC = [C.x - B.x, C.y - B.y, C.z - B.z];
	const dotProduct = BA[0] * BC[0] + BA[1] * BC[1] + BA[2] * BC[2];
	const magnitudeBA = Math.sqrt(BA[0] ** 2 + BA[1] ** 2 + BA[2] ** 2);
	const magnitudeBC = Math.sqrt(BC[0] ** 2 + BC[1] ** 2 + BC[2] ** 2);
	const cosTheta = dotProduct / (magnitudeBA * magnitudeBC);
	const angleRad = Math.acos(cosTheta);
	const angleDeg = angleRad * (180 / Math.PI);
	return parseFloat(angleDeg);
}

export async function startPoseDetection() {
	var that = this;


	const poseDetectionLoop = async () => {
		// Draw video frame to canvas5
		that.ctx5.drawImage(that.video, 0, 0, that.video.offsetWidth, that.video.offsetHeight);

		// Pose estimation configuration
		const estimationConfig = {
			flipHorizontal: false
		};

		// Estimate poses from the video
		const poses = await that.detector.estimatePoses(that.canvas5, estimationConfig);
		that.fps_count++;
		that.fix_dat(poses);
		requestAnimationFrame(poseDetectionLoop);
	};

	poseDetectionLoop();
}

export function fix_dat(poses) {
	var that = this
	var vl = 1; // Scaling factor for coordinates
	poses.forEach(pose => {
		if (!that.$data.zt) return; // Exit if tracking is disabled

		// Clear canvas4
		that.ctx4.clearRect(0, 0, that.canvas4.width, that.canvas4.height);

		// Draw background if required
		if (!that.$data.vst) {
			that.ctx4.fillStyle = '#000000';
			that.ctx4.fillRect(0, 0, that.canvas4.width, that.canvas4.height);
		}

		// Draw video frame to canvas4
		that.ctx4.drawImage(that.video, 0, 0, that.video.offsetWidth, that.video.offsetHeight);

		// Store keypoints in a temporary object
		const keypoints = {};
		pose.keypoints.forEach(keypoint => {
			keypoints[keypoint.name] = keypoint;
		});

		const head = keypoints['nose'];
		const leftHip = keypoints['left_hip'];
		const rightHip = keypoints['right_hip'];

		if (head && head.score > 0.95 && leftHip && rightHip) {
			if (!that.is_init) {
				that.is_init = true;
				that.vst = false;
			}

			const showLeftSide = head.x < (leftHip.x + rightHip.x) / 2;
			that.$data.dat.see_fx.val = showLeftSide ? '左侧' : '右侧';

			const side_list = ["knee", "hip", "ankle", "shoulder", "elbow", "wrist"];
			const side_prefix = showLeftSide ? 'left_' : 'right_';

			// Process keypoints
			Object.entries(keypoints).forEach(([name, {
				x,
				y
			}]) => {
				x *= vl.toFixed(2);
				y *= vl.toFixed(2);

				// Highlight specific side joints
				if (side_list.some(suffix => name.includes(side_prefix + suffix))) {
					that.ctx4.beginPath();
					that.ctx4.arc(x, y, 8, 0, 2 * Math.PI);

					if (that.map_name == name.split('_')[1]) {
						that.ctx4.fillStyle = '#ef0006';
						that.ctx4.strokeStyle = '#ef0006';
					} else {
						that.ctx4.fillStyle = '#0e00f1';
						that.ctx4.strokeStyle = '#0e00f1';
					}

					that.ctx4.fill();
					that.ctx4.lineWidth = 2;
					that.ctx4.stroke();
				}

				// Draw specific joints on other canvases
				if (name === side_prefix + 'hip') {
					that.ctx6.beginPath();
					that.ctx6.arc(x / 3, y / 3, 1, 0, 1 * Math.PI);
					that.ctx6.fillStyle = 'green';
					that.ctx6.fill();
				}

				if (name === side_prefix + 'ankle') {
					that.ctx2.beginPath();
					that.ctx2.arc(x / 3, y / 3, 1, 0, 1 * Math.PI);
					that.ctx2.fillStyle = 'green';
					that.ctx2.fill();
				}

				if (name === side_prefix + 'knee') {
					that.ctx3.beginPath();
					that.ctx3.arc(x / 3, y / 3, 1, 0, 1 * Math.PI);
					that.ctx3.fillStyle = 'green';
					that.ctx3.fill();

					that.dat_knee[0] = [x, y];
				}

				if (name === side_prefix + 'foot_index') {
					that.dat_knee[1] = [x, y];
					if ((showLeftSide && that.foot_index_max < x) || (!showLeftSide && that.foot_index_max > x) || that.foot_index_max == 0) {
						that.foot_index_max = x;
						that.updateknee_x(that.dat_knee, showLeftSide);
					}
				}
			});

			// Draw limbs
			const limbs = showLeftSide ? [
				['left_shoulder', 'left_hip', 'left_knee'],
				['left_hip', 'left_knee', 'left_ankle'],
				['left_knee', 'left_ankle', 'left_foot_index'],
				['left_elbow', 'left_shoulder', 'left_hip'],
				['left_shoulder', 'left_elbow', 'left_wrist'],
				['left_index', 'left_wrist', 'left_elbow'],
			] : [
				['right_shoulder', 'right_hip', 'right_knee'],
				['right_hip', 'right_knee', 'right_ankle'],
				['right_knee', 'right_ankle', 'right_foot_index'],
				['right_elbow', 'right_shoulder', 'right_hip'],
				['right_shoulder', 'right_elbow', 'right_wrist'],
				['right_index', 'right_wrist', 'right_elbow'],
			];

			limbs.forEach(limb => {
				if (limb.length === 3) {
					const [startPart, middlePart, endPart] = limb;
					const names = middlePart.split("_")[1];
					const startKeypoint = keypoints[startPart];
					const middleKeypoint = keypoints[middlePart];
					const endKeypoint = keypoints[endPart];
					if (startKeypoint && middleKeypoint && endKeypoint) {
						const angle = that.calculateAngle(startKeypoint, middleKeypoint, endKeypoint);
						if (side_list.includes(names)) {
							that.u_avg(names, angle);
						}
						that.ctx4.beginPath();
						that.ctx4.moveTo(startKeypoint.x * vl, startKeypoint.y * vl);
						that.ctx4.lineTo(middleKeypoint.x * vl, middleKeypoint.y * vl);
						that.ctx4.lineTo(endKeypoint.x * vl, endKeypoint.y * vl);
						that.ctx4.strokeStyle = '#1db415';
						that.ctx4.lineWidth = 4;
						that.ctx4.stroke();
						// Draw labels and angles at each joint
						[
							// { keypoint: startKeypoint, label: startPart.split('_')[1] },
							{
								keypoint: middleKeypoint,
								label: `${names}: ${angle.toFixed(0)}°`,
								name: names
							}
							// ,{ keypoint: endKeypoint, label: endPart.split('_')[1] }
						].forEach(({
							keypoint,
							label,
							name
						}) => {
							const x = keypoint.x * vl;
							const y = keypoint.y * vl;

							// // Draw joint marker
							// that.ctx4.beginPath();
							// that.ctx4.arc(x, y, 8, 0, 2 * Math.PI);
							// that.ctx4.fillStyle = 'blue';
							// that.ctx4.fill();

							// Draw label
							that.ctx4.font = "bold 18px 'SimHei', 'Helvetica', sans-serif";
							// console.log(name)
							// console.log(that.$data.dat)
							that.ctx4.fillStyle = that.$data.dat[name].color;
							that.ctx4.fillText(label, x + 10, y - 10); // Adjust the text position
						});
					}
				}
			});
			// limbs.forEach(limb => {
			//     if (limb.length === 3) {
			//         const [startPart, middlePart, endPart] = limb;
			//         const names = middlePart.split("_")[1];
			//         const startKeypoint = keypoints[startPart];
			//         const middleKeypoint = keypoints[middlePart];
			//         const endKeypoint = keypoints[endPart];

			//         if (startKeypoint && middleKeypoint && endKeypoint) {
			//             // Calculate the angle at the middle joint
			//             const angle = that.calculateAngle(startKeypoint, middleKeypoint, endKeypoint);

			//             // If the joint is in the selected list, update averages
			//             if (side_list.includes(names)) {
			//                 that.u_avg(names, angle);
			//             }

			//             // Draw the limb lines
			//             that.ctx4.beginPath();
			//             that.ctx4.moveTo(startKeypoint.x * vl, startKeypoint.y * vl);
			//             that.ctx4.lineTo(middleKeypoint.x * vl, middleKeypoint.y * vl);
			//             that.ctx4.lineTo(endKeypoint.x * vl, endKeypoint.y * vl);
			//             that.ctx4.strokeStyle = '#1db415';
			//             that.ctx4.lineWidth = 4;
			//             that.ctx4.stroke();

			//             // Draw labels and angles at each joint
			//             [
			//                 { keypoint: startKeypoint, label: startPart.split('_')[1] },
			//                 { keypoint: middleKeypoint, label: `${names}: ${angle.toFixed(1)}°` },
			//                 { keypoint: endKeypoint, label: endPart.split('_')[1] }
			//             ].forEach(({ keypoint, label }) => {
			//                 const x = keypoint.x * vl;
			//                 const y = keypoint.y * vl;

			//                 // Draw joint marker
			//                 that.ctx4.beginPath();
			//                 that.ctx4.arc(x, y, 8, 0, 2 * Math.PI);
			//                 that.ctx4.fillStyle = 'blue';
			//                 that.ctx4.fill();

			//                 // Draw label
			//                 that.ctx4.font = "14px Arial";
			//                 that.ctx4.fillStyle = "white";
			//                 that.ctx4.fillText(label, x + 10, y - 10); // Adjust the text position
			//             });
			//         }
			//     }
			// });
		}
	});
}
export async function searchDevice() {
	alert("当前仅支持智骑Fitting车.")
	try {
		// 请求用户选择蓝牙设备
		const device = await navigator.bluetooth.requestDevice({
			acceptAllDevices: true,
			optionalServices: ["00001818-0000-1000-8000-00805f9b34fb"], // Cycling Power Service UUID
		});
		console.log(`设备已选择: ${device.name}`);
		this.connectedDevice = device;

		// 连接到 GATT 服务器
		const server = await device.gatt.connect();
		console.log("GATT 服务器已连接");

		// 获取 Cycling Power Service
		const service = await server.getPrimaryService("00001818-0000-1000-8000-00805f9b34fb");
		console.log("Cycling Power 服务获取成功");

		// 获取 Cycling Power Control Point 特征
		const controlPointCharacteristic = await service.getCharacteristic("00002a66-0000-1000-8000-00805f9b34fb");
		this.controlPointCharacteristic = controlPointCharacteristic;
		console.log("Cycling Power Control Point 特征获取成功");

		// 获取 Cycling Power Measurement 特征
		const measurementCharacteristic = await service.getCharacteristic("00002a63-0000-1000-8000-00805f9b34fb");
		this.measurementCharacteristic = measurementCharacteristic;
		console.log("Cycling Power Measurement 特征获取成功");

		// 开始监听 Measurement 特征值
		measurementCharacteristic.addEventListener("characteristicvaluechanged", this.handleMeasurementValueChanged);
		await measurementCharacteristic.startNotifications();
		console.log("开始监听 Cycling Power Measurement 特征值变化");
		this.wt_set = true;
	} catch (error) {
		console.error(`操作失败: ${error.message}`);
	}
}
export function arrayBufferToHex(buffer) {
	let view = new DataView(buffer);
	let hexStr = '';
	for (let i = 0; i < view.byteLength; i++) {
		hexStr += view.getUint8(i).toString(16).padStart(2, '0');
	}
	return hexStr;
}
export function handleMeasurementValueChanged(event) {
	const value = event.target.value;

	// 检查数据长度（假设 CPS 数据包为 16 字节）
	if (value.byteLength < 16) {
		console.error("Measurement value length is too short:", value.byteLength);
		return;
	}

	// 使用 DataView 解析数据（小端序）
	const data = new DataView(value.buffer);

	// 解析各字段（根据 CPS Cycling Power Measurement 的格式）
	const flags = data.getUint16(0, true);
	const instantaneousPower = data.getInt16(2, true); // 即时功率，单位：瓦特
	const accumulatedTorque = data.getUint16(4, true); // 累计扭矩（单位：1/32 Nm，可根据设备文档换算）
	const cumulativeWheelRevs = data.getUint32(6, true); // 车轮累计转数
	const lastWheelEventTime = data.getUint16(10, true); // 最近车轮事件时间（单位 1/2048 秒）
	const cumulativeCrankRevs = data.getUint16(12, true); // 曲柄累计转数
	const lastCrankEventTime = data.getUint16(14, true); // 最近曲柄事件时间（单位 1/1024 秒）

	// 如果没有上一次的曲柄数据，则先保存当前值，等待下一次通知
	if (this.prevCumulativeCrankRevs === undefined || this.prevCrankEventTime === undefined) {
		this.prevCumulativeCrankRevs = cumulativeCrankRevs;
		this.prevCrankEventTime = lastCrankEventTime;
		return;
	}

	// 计算累计曲柄转数和事件时间的差值
	let deltaRevs = cumulativeCrankRevs - this.prevCumulativeCrankRevs;
	let deltaTime = lastCrankEventTime - this.prevCrankEventTime;

	// 考虑字段回绕（16位无符号数）
	if (deltaRevs < 0) {
		deltaRevs += 0x10000;
	}
	if (deltaTime < 0) {
		deltaTime += 0x10000;
	}

	// lastCrankEventTime 的单位为 1/1024 秒，转换为秒
	const deltaSeconds = deltaTime / 1024;

	// 根据曲柄转数差值和时间差计算踏频（rpm）
	let cadence = 0;
	if (deltaSeconds > 0) {
		cadence = (deltaRevs / deltaSeconds) * 60;
	}



	// 根据即时功率和踏频计算当前踩踏扭矩
	// 首先计算角速度，单位为 rad/s： cadence * (2π/60)
	let pedalTorque = 0;
	if (cadence > 0) {
		const angularVelocity = (cadence * 2 * Math.PI) / 60; // rad/s
		pedalTorque = instantaneousPower / angularVelocity;
	}

	console.log("Instantaneous Power:", instantaneousPower, "W", "Cadence:", cadence.toFixed(1), "rpm", "Pedal Torque:", pedalTorque.toFixed(2), "Nm");
	this.wts = instantaneousPower;
	this.tp = cadence.toFixed(1);
	this.nm = pedalTorque.toFixed(2);
	// 更新上一次的累计值和时间戳，供下次计算使用
	this.prevCumulativeCrankRevs = cumulativeCrankRevs;
	this.prevCrankEventTime = lastCrankEventTime;
}

export async function disconnectDevice() {
	if (this.connectedDevice && this.connectedDevice.gatt.connected) {
		this.connectedDevice.gatt.disconnect();
		console.log("设备已断开连接");
		this.wt_set = false;
		this.connectedDevice = null;
		this.controlPointCharacteristic = null;
		this.measurementCharacteristic = null;
		this.measurementValue = null;
	}
}
export function init_mode_list() {
	var that = this
	var id = localStorage.getItem('mode_id');
	console.log(id);
	console.log(parseInt(id))
	if (parseInt(id) <= 0 || id == null) {
		id = 2;
	}
	$.ajax({
		url: that.URL,
		method: "POST",
		data: {
			t: "init_mode",
			id: id,
			token: localStorage.getItem('token'),
		},
		dataType: "json",
		success(e) {
			console.log(e);
			that.mode_list = e.list;
			that.dat_lines = that.mode_list[0]
			that.dat_line.knee.u_min = that.dat_lines.dat.knee.u_min;
			that.dat_line.knee.u_max = that.dat_lines.dat.knee.u_max;
			that.dat_line.knee.d_min = that.dat_lines.dat.knee.d_min;
			that.dat_line.knee.d_max = that.dat_lines.dat.knee.d_max;
			
			that.dat_line.hip.u_min = that.dat_lines.dat.hip.u_min;
			that.dat_line.hip.u_max = that.dat_lines.dat.hip.u_max;
			that.dat_line.hip.d_min = that.dat_lines.dat.hip.d_min;
			that.dat_line.hip.d_max = that.dat_lines.dat.hip.d_max;
			
			that.dat_line.shoulder.u_min = that.dat_lines.dat.shoulder.u_min;
			that.dat_line.shoulder.u_max = that.dat_lines.dat.shoulder.u_max;
			
			that.dat_line.elbow.u_min = that.dat_lines.dat.elbow.u_min;
			that.dat_line.elbow.u_max = that.dat_lines.dat.elbow.u_max;
			
			that.dat_line.ankle.u_min = that.dat_lines.dat.ankle.u_min;
			that.dat_line.ankle.u_max = that.dat_lines.dat.ankle.u_max;
			
			that.dat_line.wrist.u_min = that.dat_lines.dat.wrist.u_min;
			that.dat_line.wrist.u_max = that.dat_lines.dat.wrist.u_max;
		}
	})
}
export function save_mode(sta) {
	var that = this

	var dat = JSON.parse(JSON.stringify(that.dat_lines));
	if (sta == 1) {
		dat.id = 0;
	}
	dat.t = "save_mode";
	dat.token = localStorage.getItem('token');
	dat.dat = JSON.stringify(dat.dat);

	$.ajax({
		url: that.URL + "?token=" + localStorage.getItem('token'),
		method: "POST",
		data: dat,
		dataType: "json",
		success(e) {
			
			$.ajax({
				url: that.URL,
				method: "POST",
				data: {
					t: "init_mode",
					id: e.id,
					token: localStorage.getItem('token'),
				},
				dataType: "json",
				success(e) {
					console.log(e);
					that.mode_list = e.list;
					that.dat_lines = that.mode_list[0]
					that.sel_mode_index=0;
					alert("保存成功");
				}
			})
		}
	})
}
export function mode_change() {
	var that = this
	console.log(that.dat_lines)
	console.log(that.mode_list[that.sel_mode_index]);
	that.dat_lines = that.mode_list[that.sel_mode_index]
}
export function apply_mode() {
	var that = this
	that.dat_line.knee.u_min = that.dat_lines.dat.knee.u_min;
	that.dat_line.knee.u_max = that.dat_lines.dat.knee.u_max;
	that.dat_line.knee.d_min = that.dat_lines.dat.knee.d_min;
	that.dat_line.knee.d_max = that.dat_lines.dat.knee.d_max;

	that.dat_line.hip.u_min = that.dat_lines.dat.hip.u_min;
	that.dat_line.hip.u_max = that.dat_lines.dat.hip.u_max;
	that.dat_line.hip.d_min = that.dat_lines.dat.hip.d_min;
	that.dat_line.hip.d_max = that.dat_lines.dat.hip.d_max;

	that.dat_line.shoulder.u_min = that.dat_lines.dat.shoulder.u_min;
	that.dat_line.shoulder.u_max = that.dat_lines.dat.shoulder.u_max;

	that.dat_line.elbow.u_min = that.dat_lines.dat.elbow.u_min;
	that.dat_line.elbow.u_max = that.dat_lines.dat.elbow.u_max;

	that.dat_line.ankle.u_min = that.dat_lines.dat.ankle.u_min;
	that.dat_line.ankle.u_max = that.dat_lines.dat.ankle.u_max;

	that.dat_line.wrist.u_min = that.dat_lines.dat.wrist.u_min;
	that.dat_line.wrist.u_max = that.dat_lines.dat.wrist.u_max;
	localStorage.setItem('mode_id',that.dat_lines.id);
	alert("应用成功");
	
}